
import RadialProgressBar from 'vue-radial-progress'

export default {
  components: {
    RadialProgressBar,
  },
  props: {
    percentage: {
      type: [Number, String],
      default: 0,
    },
    title: {
      type: String,
      default: null,
    },
    fillColor: {
      type: String,
      default: '#174C54',
    },
    emptyColor: {
      type: String,
      default: '#d8e3e8',
    },
    speed: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      completedSteps: 0,
      totalSteps: 100,
    }
  },
  mounted() {
    setTimeout(() => {
      this.completedSteps = this.percentage
    }, 500)
  },
}
